"use client";

import { useAuth } from "@clerk/nextjs";
import { useEffect } from "react";
import { setClerkGetToken } from "./index";

/**
 * Component that bridges Clerk authentication with Apollo Client
 * This must be rendered inside ClerkProvider and before any Apollo queries
 *
 * It registers Clerk's getToken function so Apollo can refresh expired tokens
 */
export function ClerkApolloBridge({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth();

  useEffect(() => {
    // Register the getToken function with Apollo's error handler
    // Using skipCache: true to force a fresh token from Clerk
    setClerkGetToken(() => getToken({ skipCache: true }));
  }, [getToken]);

  return <>{children}</>;
}


